// extracted by mini-css-extract-plugin
export default {"sidebar":"InsertGroupMembersSidebar_sidebar__MVq9p","open":"InsertGroupMembersSidebar_open__-korD"};